module.exports = __webpack_public_path__ + "img/setaLado.f7d7ea22.svg";